import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import CarouselOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('carousel', {
  template: require('./template.html'),
  mixins: [guid, cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    profile() {
      return this._dropletType(this.droplet);
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    routeWatch() {
      const r = this.$store.getters.route;
      if (r === 'page-editor') {
        this.unBindPlugin();
        this.bindPlugin();
      }
      return r;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzCarousel-container' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        perspective: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        'box-shadow': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  name: 'carousel',
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    CarouselOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzCarousel-container',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
      setTimeout(() => {
        this.unBindPlugin();
        this.bindPlugin();
      }, 1000);
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  mounted() {
    // need to give the plugin a slight delay to properly
    // calculate the carousel container width
    $(document).ready(() => {
      setTimeout(() => {
        this.bindPlugin();
      }, 250);
    });
    this.callCssGenerator();
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    bindPlugin() {
      const $carousel = $(this.$refs.carousel);
      $carousel.drzCarousel();
    },
    unBindPlugin() {
      const $carousel = $(this.$refs.carousel);
      if ($carousel.drzCarousel.destroy) {
        $carousel.drzCarousel.destroy($carousel);
      }
    },
    async toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
      if (!this.showEditBubble) {
        await this.$store.dispatch('setCarouselLimits', {
          drp: this.droplet,
          showAll: false,
          itemLimit: 5,
        });
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/carousel/index.js